<template>
  <div id="help" class="content">
    <div class="section-title">
      <div class="row">
        <div class="col-md-6">
          <h3>{{ title }}</h3>
        </div>
        <div class="col-md-6"></div>
      </div>
      <hr />
    </div>
    <span><strong>Descarga la siguiente información:</strong></span>
    <div class="row" style="padding-top: 3rem">
      <div
        class="col-xl-3 col-lg-6 col-md-6 col-12 pointer pdf-box"
        v-for="(file, index) in files"
        :key="index"
        @click="downloadHelpFile(file.id, file.name)"
      >
        <div class="pdf-inner-box" style="text-align: center;">
          <div class="pdf-animate">
            <div>
              <img
                width="70"
                height="70"
                :src="require(`@/assets/images/pdf-300x300.png`)"
                alt="Documento PDF"
              />
            </div>
            <div style="margin-top: 1rem">
              <span
                style="color: #ff0558; font-weight: bold; font-size: 1.5rem;line-height: 30px"
                >{{ file.name }}</span
              >
            </div>
          </div>
          <div class="download-animate">
            <img
              width="140"
              height="140"
              :src="require(`@/assets/images/descarga.png`)"
              alt="Descargar"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import FilesService from "@/services/file.service";
import { saveAs } from "file-saver";

export default {
  name: "Help",
  data() {
    return {
      title: "INFORMACIÓN PODOSHOPS",
      files: [],
      totalFiles: 0
    };
  },
  mounted() {
    this.getHelpFiles();
  },
  methods: {
    /* Obtiene la lista de archivos */
    getHelpFiles() {
      FilesService.getAllHelpFiles()
        .then(response => {
          this.files = response.data.data.content;
          this.totalFiles = response.data.data.totalElements;
        })
        .catch(() => {
          this.$notify({
            title: "Error",
            message:
              "Se ha producido un error al obtener el listado de archivos",
            type: "error",
            duration: 4000
          });
        });
    },

    /* Descarga un archivo en concreto */
    downloadHelpFile(helpFileID, helpFileName) {
      FilesService.downloadHelpFile(helpFileID)
        .then(response => {
          this.$notify({
            title: "Confirmación",
            message: "Archivo descargado correctamente",
            type: "success",
            duration: 4000
          });
          const blob = new Blob([response.data], {
            type: "application/pdf"
          });
          saveAs(blob, helpFileName);
        })
        .catch(() => {
          this.$notify({
            title: "Error",
            message: "Error al descargar el archivo",
            type: "error",
            duration: 4000
          });
        });
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/sass/styles";
#help {
  width: 100%;
  height: auto;
  .flex-container {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin-left: 5rem;
    margin-right: 5rem;
  }
  .pdf-box {
    width: 20%;
    position: relative;
  }
  .pdf-inner-box {
    border: 2px solid #ff0558;
    padding: 2rem;
    height: 15rem;
    display: inline-flex;
    width: 100%;
    margin-bottom: 20px;
    &:hover {
      .pdf-animate {
        animation-name: fade-out-left;
        animation-duration: 0.25s;
        animation-fill-mode: forwards;
        display: none;
      }
      .download-animate {
        animation-name: fade-in-right;
        animation-duration: 0.25s;
        animation-fill-mode: forwards;
        display: inline-block;
      }
    }
  }
  .pdf-animate {
    position: relative;
    animation-name: fade-in-left;
    animation-duration: 0.25s;
    animation-fill-mode: initial;
    display: inline-block;
    min-width: 100%;
  }
  .download-animate {
    position: relative;
    animation-name: fade-out-right;
    animation-duration: 0.25s;
    animation-fill-mode: initial;
    min-width: 100%;
    display: none;
  }
}

@keyframes fade-out-left {
  0% {
    right: 0;
    opacity: 100% !important;
  }
  100% {
    right: 100px;
    opacity: 0 !important;
  }
}
@keyframes fade-out-right {
  0% {
    left: 0;
    opacity: 100% !important;
  }
  100% {
    left: 100px;
    opacity: 0 !important;
  }
}
@keyframes fade-in-right {
  0% {
    left: 100px;
    opacity: 0 !important;
  }
  100% {
    left: 0;
    opacity: 100% !important;
  }
}
@keyframes fade-in-left {
  0% {
    right: 100px;
    opacity: 0 !important;
  }
  100% {
    right: 0;
    opacity: 100% !important;
  }
}
@media (max-width: 430px) {
  .pdf-box {
    width: 100%;
    margin-bottom: 2rem;
  }
  .flex-container {
    margin-right: 0;
    margin-left: 0;
  }
}
</style>
